module.exports = __webpack_public_path__ + "static/media/preview_stamp_card.4f645892.svg";